import { Component, Inject } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";

import { DocumentPaService } from '../../services/document-pa-service';

import { StaticTypeService } from '../../../../static-types/services/static-types.service';

import { PaSearchCriteria } from '../../entities/personne-avertie-search-criteria';
import { DocumentPersonneAvertieResult } from "../../entities/document-personne-avertie-result";
import { DocumentPaSteps } from '../../../../static-types/entities/document-pa-steps';
import { CategoriePa } from '../../entities/document-pa.entity';
import { ParcService } from '../../../structure/parc/services/parc.service';
import { ParcTLR } from '../../../structure/parc/entities/parc-tlr.entity';
import { StepDefinitionPaEntity } from '../../entities/document-pa-step-definition-data.entity';

@Component({
	selector: 'gestion-documents-pa',
	templateUrl: 'gestion-documents-pa.html',
	styleUrls: ['gestion-documents-pa.css']
})
export class GestionDocumentPaComponent {

	filterResults$ = new Subject<PaSearchCriteria>();

	view: string = 'list';
	editCommands: Subject<DocumentPersonneAvertieResult> = new Subject<DocumentPersonneAvertieResult>();
	initListCommands: Subject<void> = new Subject<void>();

	paCategories: typeof CategoriePa = CategoriePa;
	
	steps$ = new BehaviorSubject<DocumentPaSteps[] | null>(null);
	
	currentCategorie = CategoriePa.PV;

	constructor(@Inject(DocumentPaService) private documentPaService: DocumentPaService, @Inject(StaticTypeService) staticTypeService: StaticTypeService, @Inject(ParcService) private parcService: ParcService) {
		
		staticTypeService.getPaSteps().subscribe(
			(steps) => {
				this.steps$.next(steps);
			}
		);
	}

	changeView(view: 'list' | 'steps') {
		if (view === 'list') {
			this.initListCommands.next();
		}
		this.view = view;
	}

	ajouterDocumentPa() {
		let stepDefinitionPaEntity = new StepDefinitionPaEntity();
		stepDefinitionPaEntity.categoriePa = CategoriePa.PV; // PV par défaut
		this.createPa(stepDefinitionPaEntity);
	}
	
	handleParcEnergieChange(stepDefinitionPaEntity: StepDefinitionPaEntity) {
		this.createPa(stepDefinitionPaEntity);
	}

	createPa(stepDefinitionPaEntity: StepDefinitionPaEntity) {
		this.currentCategorie = stepDefinitionPaEntity.categoriePa;
		let paToEdit: DocumentPersonneAvertieResult = new DocumentPersonneAvertieResult();
		paToEdit.id = -1;
		paToEdit.categorie = this.currentCategorie;
		if (stepDefinitionPaEntity.dateDebut) {
			paToEdit.dateDebut = stepDefinitionPaEntity.dateDebut;
		}
		if (stepDefinitionPaEntity.dateFin) {
			paToEdit.dateFin = stepDefinitionPaEntity.dateFin;
		}
		if (stepDefinitionPaEntity.numeroPa) {
			paToEdit.numeroPa = stepDefinitionPaEntity.numeroPa;
		}
		if (stepDefinitionPaEntity.commune) {
			paToEdit.commune = stepDefinitionPaEntity.commune;
		}
		if (stepDefinitionPaEntity.duree) {
			paToEdit.duree = stepDefinitionPaEntity.duree;
		}
		if (stepDefinitionPaEntity.horaires) {
			paToEdit.horaires = stepDefinitionPaEntity.horaires;
		}
		if (stepDefinitionPaEntity.nombreIntervenants) {
			paToEdit.nombreIntervenants = stepDefinitionPaEntity.nombreIntervenants;
		}
		if (stepDefinitionPaEntity.description) {
			paToEdit.description = stepDefinitionPaEntity.description;
		}
		if (stepDefinitionPaEntity.parcIds && stepDefinitionPaEntity.parcIds.length) {
			paToEdit.parcIds = stepDefinitionPaEntity.parcIds[0].toString();
		}
		this.editCommands.next(paToEdit);
		this.changeView('steps');
	}

	modifierDocumentPa(paToEdit: DocumentPersonneAvertieResult) {
		if (paToEdit.parcIds) {
			let parcIds = paToEdit.parcIds.split(',');
			this.parcService.getParcTLRById(Number(parcIds[0])).subscribe(
				(parc: ParcTLR) => {
					this.currentCategorie = parc.energie === 'Eolienne' ? CategoriePa.EOL : CategoriePa.PV;
					paToEdit.categorie = this.currentCategorie;
					this.editCommands.next(paToEdit);
					this.changeView('steps');
				}
			);
		}
	}

}